import { isBoolean, isNil, isString, toLower } from 'lodash'

const isBooleanTrue = value => {
  if (isNil(value)) {
    return false
  }

  if (isBoolean(value)) {
    return value
  }

  if (isString(value)) {
    return toLower(value) === 'true'
  }

  throw new Error('Not a boolean')
}

export default isBooleanTrue
